/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SeverityEnum } from './severityEnum';


export interface VcdsDeploymentSystemIssue { 
    args?: Array<string>;
    /**
     * Error code
     */
    code?: string;
    /**
     * Error message
     */
    message?: string;
    severity?: SeverityEnum;
}
export namespace VcdsDeploymentSystemIssue {
}


